import { render, staticRenderFns } from "./CustomSelectsImprove.vue?vue&type=template&id=4a9f6e9a&"
import script from "./CustomSelectsImprove.vue?vue&type=script&lang=js&"
export * from "./CustomSelectsImprove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
